import React from 'react';
import moment from 'moment';
import RectangularButton from 'components/elements/molecules/RectangularButton/RectangularButton';

export default function SyllabusUploadStep3({
  rows,
  course,
  deliveryPreferences,
  syllabusData,
  onDone,
}) {
  const count = rows.length;

  const dates = rows
    .map((r) => r.date)
    .filter(Boolean)
    .sort();

  const firstDate = dates.length ? moment(dates[0]).format('MMM D') : '';
  const lastDate = dates.length
    ? moment(dates[dates.length - 1]).format('MMM D')
    : '';
  const dateRange = firstDate && lastDate ? `${firstDate} – ${lastDate}` : '';

  const courseName = course && (course.name || course.courseName || '');

  const firstSunday = dates.length
    ? moment(dates[0]).subtract(1, 'day').format('MMM D')
    : '';
  const deliveryDay = deliveryPreferences?.deliveryDay || 'Sunday';
  const deliveryDayLower = deliveryDay.toLowerCase();
  const generatedDetails =
    syllabusData?.generatedDetails || syllabusData?.syllabus?.generatedDetails || {};
  const lectureWeeksConfigured =
    generatedDetails.lectureWeeksConfigured ||
    `${count} lecture week${count !== 1 ? 's' : ''} configured`;
  const dateRangeSummary =
    generatedDetails.dateRangeSummary ||
    [courseName, dateRange].filter(Boolean).join(' · ');
  const reviewPublishSummary =
    generatedDetails.reviewPublishSummary ||
    `Each ${deliveryDayLower}, we'll email you 10 suggested articles for the upcoming week's lecture. You'll be able to review, edit, and publish them to students from the course topics page.`;
  const firstSuggestionSummary =
    generatedDetails.firstSuggestionSummary ||
    (firstSunday
      ? `First suggestions arrive ${deliveryDay}, ${firstSunday}. You can pause or update this in Settings.`
      : '');

  return (
    <div className="syllabus-step">
      <div className="main-con">
        <div className="modal-header">
          <div className="syllabus-step-title">You're all set</div>
        </div>
        <div className="section-con">
          <div className="syllabus-confirmation-box">
            <div className="font-weight-600 mb-1">{lectureWeeksConfigured}</div>
            <div className="av-gray">{dateRangeSummary}</div>
          </div>

          <p className="syllabus-step-desc mt-3">{reviewPublishSummary}</p>

          {firstSuggestionSummary && (
            <p
              className="syllabus-step-desc av-gray"
              style={{ fontStyle: 'italic' }}
            >
              {firstSuggestionSummary}
            </p>
          )}
        </div>
        <div className="syllabus-step-footer">
          <div />
          <RectangularButton darkButton onClick={onDone}>
            Done
          </RectangularButton>
        </div>
      </div>
    </div>
  );
}
